import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
// import logo from './logo.svg';
import "./App.css";
import Header from "./Component/header";
// import Home from './Component/home';
// import Services from './Component/services';
// import Counter from './Component/counter';
// import Expertise from './Component/expertise';
// import Contact from './Component/contactUs';
import GetInTouch from "./Component/getInTouch";
import Footer from "./Component/footer";
import Mainscreen from "./Component/mainscreen";
import Career from "./Component/career";
import SkillDevelopment from "./Component/skillDevelopment";
import Jobs from "./Component/jobs";
import ServicesPage from "./Component/servicesPage";
import AboutUs from "./Component/aboutUs";
import ScrollToTop from "./Component/ScrollToTop";
//  import DbConnection from './API/dbConnection';
import JobApplication from "./Component/jobApplication";
import TermsAndConditions from "./Component/terms&condition";
import PrivacyPolicy from "./Component/privacyPolicy";
import Portfolio from "./Component/Portfolio";
import Newservices from "./Component/Newservices";
function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Mainscreen />}></Route>
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/home" element={<Navigate to="/" />} />
          <Route path="/career" element={<Career />}></Route>
          <Route path="/training" element={<SkillDevelopment />}></Route>
          <Route path="/contact" element={<GetInTouch />}></Route>
          <Route path="/jobs" element={<Jobs />}></Route>
          <Route path="/services" element={<ServicesPage />}></Route>
          <Route path="/about" element={<AboutUs />}></Route>
          <Route path="/apply" element={<JobApplication />}></Route>
          <Route path="/terms" element={<TermsAndConditions />}></Route>
          <Route path="/privacy" element={<PrivacyPolicy />}></Route>
          <Route path="/portfolio" element={<Portfolio />}></Route>
          <Route path="/newservices" element={<Newservices />}></Route>
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
